import { Pipe, PipeTransform } from '@angular/core';

// This pipe formats a camelCase string into a more readable format by adding spaces before uppercase letters.
// The first letter isn't capitalised, and it handles special cases like "pH".

@Pipe({
  name: 'formatCamelCaseAlt',
})
export class FormatCamelCaseAltPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';

    const stringValue = String(value);
    // Preserve "pH" without adding spaces
    const preservedPH = stringValue.replace(/pH/g, 'p_H'); // Temporarily replace "pH" with a placeholder

    // Add a space before each uppercase letter unless it's part of consecutive uppercase letters
    const result = preservedPH
      // Look for uppercase letters followed by lowercase letters and add a space before them
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
      // Add a space before any standalone uppercase letter that is followed by a lowercase letter
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .trim();

    // Restore the placeholder "p_H" back to "pH"
    const finalResult = result.replace(/p_H/g, 'pH');

    return finalResult;
  }
}
